<template>
	 <v-container>
		 <v-dialog title="课程余额结转" v-model="hideShow" width="500px" persistent>
			<v-card>
				<v-card-title>
					<span>课程余额结转</span>
					<v-spacer></v-spacer>
					<v-icon @click="cancel">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-5">
					<v-row dense>
						<v-col cols="12">
							<span style="color: red; font-weight: 500;">注:将剩余课时全部转入目标课程账户</span>
						</v-col>
					</v-row>
					<v-row dense v-if="account" class="mt-5">
						<v-col cols="6">
							<v-text-field label="学员姓名" v-model="account.studentName" disabled dense outlined></v-text-field>
						</v-col>
						<v-col cols="6">
							<v-text-field label="课程名称" v-model="account.courseName" disabled dense outlined></v-text-field>
						</v-col>
						<v-col cols="6">
							<v-text-field label="课时余额" v-model="account.balanceHour" disabled dense outlined></v-text-field>
						</v-col>
						<v-col cols="6">
							<v-text-field label="金额余额" v-model="account.balanceFee" disabled dense outlined></v-text-field>
						</v-col>
						<v-col cols="12" class="mt-n6">
							<v-select :items="availiableCourseList" v-model="transfer.courseId" item-text="courseName"
								item-value="id" label="转入课程名称" dense outlined></v-select>
						</v-col>
						<v-col cols="12" class="mt-n6">
							<v-text-field label="备注" v-model="transfer.memo" dense outlined></v-text-field>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="cancel">取消</v-btn>
					<v-btn @click="submitTransfer" :disabled="transfer.submitting" :loading="transfer.submitting" color="primary">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	 </v-container>
</template>

<script>
	import utils from "../config/utils"
	export default {
		name:"course-account-transfer",
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			account:{
				type:Object,
				default:null
			}
		},
		watch:{
			show(newVal,oldVal){
			
				this.hideShow = newVal;
				if(this.hideShow){
					this.transfer.courseId = "";
					this.currentCourseId = this.account.courseId;
					
					this.filterCourse();
					
				}
			}
		},
		data(){
			return {
				shopId:"",
				hideShow:this.show,
				currentCourseId:"",
				transfer:{
					submitting:false,
					courseId:"" ,//  转入的课程ID
					memo:""
				},
				selectCourseList:[],
				availiableCourseList:[]
			}
		},
		
		mounted() {
			console.log("account transfer mounted");
			this.shopId = utils.getCurrentShopId();
			this.getCourseListForSelect();
		},
		methods:{
			cancel(){
				this.$emit("cancel","");
			},
			filterCourse(){
				 
				let res = this.selectCourseList.filter((item)=>{
					return item.id != this.currentCourseId
				})
				
				this.availiableCourseList = res;
				
			},
			submitTransfer(){
				
				this.transfer.submitting = true;
				
				
				let postData = {
					sourceAccountId:this.account.id,
					targetCourseId:this.transfer.courseId,
					memo:this.transfer.memo
				}
				// api
				const that = this;
				let url = `/financial/course/account/transfer`;
					
				this.axios.post(url, postData).catch(() => {
					that.transfer.submitting = false;
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("修改成功");
							
							that.transfer.submitting = false;
							that.$emit("success","");
							return;
						} else {
							that.transfer.submitting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.transfer.submitting = false;
						that.$noty.error('网络请求失败');
					}
							
				});
			},
			getCourseListForSelect() {
				if (!this.shopId) {
					return
				}
				const that = this;
				let url = `/edu/shop/course/list/` + this.shopId;
				this.axios.get(url).then(response => {
			
					if (response.data["code"] === 200) {
						
						const list = response.data["data"] ? response.data["data"] : [];
						
						console.log("current courseId:",that.currentCourseId);
						list.forEach((item,index)=>{
							if (item.consumeType == '1' && item.status == '1' && item.id != that.currentCourseId){
								that.selectCourseList.push(item);
							}
						})
						
						return
					}
			
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
		}
	}
	
</script>

<style>
</style>
